/* eslint-disable jira/import/webpack-magic-comment-entries */
import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type OverviewNavigation from './ui/overview-navigation/index.tsx';
import type ProjectNavigation from './ui/project-navigation/MemoProjectNavigation.tsx';

const LazyHorizontalProjectNav = lazyForPaint<typeof ProjectNavigation>(
	() =>
		import(
			/* webpackChunkName: "async-business-horizontal-nav" */ './ui/project-navigation/MemoProjectNavigation.tsx'
		),
	{ entryFsSsrOverride: 'exclude' },
);

export const AsyncHorizontalProjectNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-project-nav" fallback={null}>
		<LazyHorizontalProjectNav />
	</Placeholder>
);

const LazyHorizontalOverviewNav = lazyForPaint<typeof OverviewNavigation>(
	() =>
		import(
			/* webpackChunkName: "async-business-horizontal-nav" */ './ui/overview-navigation/index.tsx'
		),
	{ entryFsSsrLiftImportToModule: false },
);

export const AsyncHorizontalOverviewNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-overview-nav" fallback={null}>
		<LazyHorizontalOverviewNav />
	</Placeholder>
);
